// Catalog order is runtime behavior: later catalogs override earlier ones.
// Shared-feature parity uses this same configuration, never a product-wide union.
module.exports = {
  languages: ['en', 'cs', 'pl'],
  products: {
    b2c: {
      customer: ['customer', 'flow', 'common'],
      flow: ['flow', 'common'],
    },
    b2b: {
      customer: ['common', 'customer'],
      flow: ['common', 'flow'],
    },
  },
}
